<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <h3 class="text-center text-success mb-1 d-flex justify-content-center align-items-center">
                        <span class="spinner-border spinner-border-sm mr-50" role="status" aria-hidden="true"></span>
                        Loading...
                    </h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { reactive, computed } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    export default {
        mounted() {
        },
        props: {
        },
        setup() {
        },
        methods: {
        },
        computed: {
        },
    }
</script>
